import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '@/api/client';
import Logo from '@/components/Logo';
import { Crown, LogIn, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function PastorLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: 'pastor@ministryofjesus.ie', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem('moj_admin_token');
    let p = null;
    try {
      p = JSON.parse(localStorage.getItem('moj_admin_profile') || 'null');
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Could not parse stored admin profile:', err);
      }
      localStorage.removeItem('moj_admin_profile');
    }
    if (t && p?.role === 'pastor') nav('/pastor');
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/admin-login', form);
      if (data.profile.role !== 'pastor') throw new Error('Not a pastor account');
      localStorage.setItem('moj_admin_token', data.token);
      localStorage.setItem('moj_admin_profile', JSON.stringify(data.profile));
      toast.success('Welcome, Pastor');
      nav('/pastor');
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-moj-cream flex items-center justify-center px-4 py-16">
      <div className="card-moj p-8 max-w-md w-full">
        <div className="flex justify-center mb-4"><Logo size="lg" showText={false}/></div>
        <div className="text-center mb-4"><Crown size={32} className="text-moj-gold-deep mx-auto"/></div>
        <h1 className="font-serif text-2xl text-center text-moj-purple-deep mb-1">Pastor Super User</h1>
        <p className="text-center text-sm text-moj-charcoal/70 mb-6">Full access to all dashboards and modules.</p>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="pastor-login-form">
          <div><label className="label-moj">Email</label><input className="input-moj" type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}/></div>
          <div><label className="label-moj">Password</label><input className="input-moj" type="password" required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}/></div>
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="pastor-login-submit"><LogIn size={16}/> {loading ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <p className="text-xs text-center text-moj-charcoal/60 mt-4 flex items-center justify-center gap-1"><ShieldCheck size={12}/> Encrypted, audit-logged. MFA placeholder for future.</p>
        <p className="text-xs text-center text-moj-charcoal/60 mt-2">Not a pastor? <Link to="/admin/login" className="text-moj-purple underline">Admin login</Link>.</p>
      </div>
    </div>
  );
}
